import {getNewOutlet, getOutlet} from 'reconnect.js';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as ApiUtil from 'rev.sdk.js/Utils/ApiUtil';
import {buildCatDisplayMap} from 'rev.sdk.js/Utils/buildCatDisplayMap';
import Config from '../../data.json';

export async function onCtxRendered() {
  let configs = null;

  if (Config.siteCacheUrl) {
    try {
      let siteCache = await ApiUtil.req(Config.siteCacheUrl, {
        headers: {
          'Cache-Control': 'no-cache',
        },
      });

      configs = siteCache.map((config) => {
        let nextConfig = {...config, id: config._id.$oid};
        return nextConfig;
      });
    } catch (ex1) {
      console.warn('[AppContext] siteCacheUrl is set but no data');
    }
  }

  if (!configs) {
    try {
      configs = await JStorage.fetchDocuments('site', {}, null, null, null, {
        anonymous: true,
      });
    } catch (ex2) {
      console.warn('[AppContext] fail to fetch site collection');
      configs = [];
    }
  }

  for (const cfg of configs) {
    if (cfg.name === 'product_category') {
      cfg.categories.meta_data = {
        ...cfg.meta_data,
      };

      getOutlet('categories').update(cfg.categories || []);
      getOutlet('categoryDisplayMap').update(
        buildCatDisplayMap(cfg.categories || []),
      );
    } else if (cfg.name === 'article_category') {
      cfg.categories.meta_data = {
        ...cfg.meta_data,
      };

      getOutlet('articleCategories').update(cfg.categories || []);
      getOutlet('articleCategoryDisplayMap').update(
        buildCatDisplayMap(cfg.categories || []),
      );
    } else if (cfg.name === 'sales_event_category') {
      cfg.categories.meta_data = {
        ...cfg.meta_data,
      };

      getOutlet('salesEventCategories').update(cfg.categories || []);
    } else if (cfg.name === 'landing') {
      getOutlet('landing').update(cfg || []);
    } else if (cfg.name === 'config') {
      getOutlet('config').update(cfg || []);
    } else if (cfg.name === 'about') {
      getOutlet('about').update(cfg || []);
    } else if (cfg.name === 'navbar_config') {
      getOutlet('navbarConfig').update(cfg);
    } else if (cfg.name === 'footer_config') {
      getOutlet('footerConfig').update(cfg);
    } else if (cfg.name === 'customer_support_config') {
      getOutlet('customer_support_config').update(cfg);
    } else if (cfg.name === 'twpaa_about_category') {
      getOutlet('twpaa_about_category').update(cfg);
    } else if (cfg.name === 'twpaa_info_category') {
      getOutlet('twpaa_info_category').update(cfg);
    } else if (cfg.name === 'law_service_application_note') {
      getOutlet('law_service_application_note').update(cfg);
    }
  }
}
